import { RecordStatus } from '@/types/api';
import { UserType } from '@/types/auth';

export const USER_TYPE_LABEL: Record<UserType, string> = {
  [UserType.SUPER_ADMIN]: 'Super Admin',
  [UserType.ADMIN]: 'QC',
  [UserType.CLIENT_ADMIN]: 'Client Admin',
  [UserType.FIELD_ADMIN]: 'Field Admin',
  [UserType.AGENT]: 'Agent',
};

export const STATUS_LABEL: Record<RecordStatus, string> = {
  [RecordStatus.ACTIVE]: 'Active',
  [RecordStatus.INACTIVE]: 'Inactive',
};
